import styled, { keyframes } from 'styled-components'

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const DrawerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .backdrop {
    height: 100vh;
    width: 100%;
    backdrop-filter: blur(10px);
    z-index: 9;
  }

  @media (max-width: 768px) {
    .backdrop {
      width: 100%;
    }
  }
`
type DrawerProps = {
  open?: boolean
}

export const Drawer = styled.nav<DrawerProps>`
  height: 100vh; // fallback in case of browser incompatibility with svh units
  max-height: 100svh; // prevent overlap with dynamic ui components (e.g. safari searchbar)
  width: 0;
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  background-color: #111;
  overflow: hidden;
  transition: all 0.2s ease;
  padding: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-color: #fff;

  .title {
    text-align: center;
  }
  .title:hover {
    transition: 0.5s;
    color: #08eddc;
  }

  &.open {
    right: 0;
    width: 720px;
    padding: 55px;
  }

  .logo {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .drawer-menu {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 154px;
    align-items: flex-start;
    width: 100%;

    .menu-options-container {
      display: flex;
      align-items: flex-start;
      gap: 40px;
      position: relative;
      .subOption {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .subOptions {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        position: relative;
        padding-left: 20px;
        animation: ${opacity} 1s ease-in-out;
        width: 100%;

        .border {
          border: 1px solid black;
          position: absolute;
          left: 0;
          height: 100%;
        }

        .subTitle:hover {
          transition: color 0.5s;
          color: #08eddc;
        }
        @media (max-width: 480px) {
          position: absolute;
          left: 7.5rem;
        }
      }
    }

    @media (max-height: 750px) {
      margin-top: calc(154px * 0.6);
    }

    @media (max-width: 480px) {
      margin: 0;
      justify-content: center;
      height: 100%;
    }
  }

  .contact {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 37px;
    .social-media {
      display: flex;
      gap: 24px;

      a {
        transition: transform 0.3s ease-in-out;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  @media (max-height: 750px) and (min-width: 769px) {
    .logo .logo-nata {
      height: calc(58px * 0.8);
      width: calc(353px * 0.6);
    }
  }
  @media (max-width: 768px) {
    &.open {
      right: 0;
      width: 100%;
      padding: 55px;
    }
  }
  @media (max-width: 720px) {
    &.open {
      right: 0;
      width: 100%;
      padding: 0;
    }
    .logo {
      padding: 16px;
    }
    .contact {
      width: 100%;
      margin-bottom: 26px;
      flex-direction: column-reverse;
      align-items: center;
      gap: 14px;
    }
    .drawer-menu {
      padding: 0 16px;
      .menu-options-container {
        gap: 10px;
      }
    }
  }
  @media (max-height: 700px) {
    .subOptions {
      transform: translateY(-50%);
    }
  }
`

type ButtonsContainerProps = {
  isBiggerMobile?: boolean
  notTranslatePage: boolean
}

export const ButtonsContainer = styled.div<ButtonsContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    !props.notTranslatePage ? 'space-between' : 'flex-end'};
  align-items: center;
  width: ${(props) => (props.isBiggerMobile ? '35%' : '30%')};
  margin-top: 20px;

  @media (max-height: 750px) {
    margin-top: 10px;
  }

  @media (max-width: 700px) {
    margin-top: 5px;
  }
  @media (max-width: 500px) {
    width: auto;
    gap: 10px;
  }
`
